import axios from "axios";
import environment from "environment";
import { getCsrfToken } from "utilities/authSession";

const client = axios.create({
  baseURL: environment.baseApi,
  headers: { "Content-Type": "application/json" },
  withCredentials: true,
});

client.interceptors.request.use((config) => {
  const csrf = getCsrfToken();
  if (csrf) {
    config.headers = config.headers || {};
    config.headers["X-CSRF-Token"] = csrf;
  }
  const token = sessionStorage.getItem("authToken");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

const result = (response) => response?.data?.result;

const authService = {
  login: (credentials) => client.post("/user/login", credentials).then(result),
  verifyMfa: (payload) => client.post("/user/mfa", payload).then(result),
  session: () => client.get("/user/session").then(result),
  logout: () => client.post("/user/logout").then(result),
  listAvatars: () => client.get("/user/avatars").then(result),
  setAvatar: (animalAvatar) =>
    client.patch("/user/avatar", { animal_avatar: animalAvatar }).then(result),
  inspectInvitation: (token) =>
    client.post("/user/invitations/inspect", { token }).then(result),
  acceptInvitation: (payload) =>
    client.post("/user/invitations/accept", payload).then(result),
  forgotPassword: (email, previousChallengeId) =>
    client
      .post("/user/password/forgot", {
        email,
        previous_challenge_id: previousChallengeId,
      })
      .then(result),
  verifyPasswordOtp: (payload) =>
    client.post("/user/password/verify", payload).then(result),
  resetPassword: (payload) =>
    client.post("/user/password/reset", payload).then(result),
  requestMfaRecovery: (loginChallengeId) =>
    client
      .post("/user/mfa/recovery/request", {
        login_challenge_id: loginChallengeId,
      })
      .then(result),
  verifyRecoveryEmail: (payload) =>
    client.post("/user/mfa/recovery/verify-email", payload).then(result),
  resendRecoveryEmail: (payload) =>
    client.post("/user/mfa/recovery/resend-email", payload).then(result),
  recoveryStatus: (payload) =>
    client.post("/user/mfa/recovery/status", payload).then(result),
  beginMfaReset: (payload) =>
    client.post("/user/mfa/recovery/begin-reset", payload).then(result),
};

export default authService;
